import script from "./MotionBank.vue?vue&type=script&setup=true&lang=js"
export * from "./MotionBank.vue?vue&type=script&setup=true&lang=js"

import "./MotionBank.vue?vue&type=style&index=0&id=0e9b2222&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e9b2222"]])

export default __exports__